export const YES = 1;
export const NO = 0;
export const KAIGO = "ဘိုးဘွားစောင့်ရှောက်ရေး";
export const HOUSIN = "HOUSHIN Business Synergies";